import React, { lazy } from "react";

const CompanyRegistration = lazy(() => import("../EMSModule/Company/CompanyRegistration"));
const Body = lazy(() => import("../LayOut/Body"));
const CompanyView = lazy(() => import("../EMSModule/Company/CompanyView"));
const Department = lazy(() => import("../CompanyModule/Department/Department"));
const Branch = lazy(() => import("../CompanyModule/Branch/Branch"));
const EmployeeView = lazy(() => import("../CompanyModule/Employee/EmployeeView"));
const RelievingManagement = lazy(() => import("../CompanyModule/ExistingProcess/RelievingManagement"));
const EmployeeSalaryStructure = lazy(() => import("../CompanyModule/PayRoll/EmployeeSalaryStructure"));
const GeneratePaySlip = lazy(() => import("../CompanyModule/PayRoll/GeneratePaySlips"));
const ViewPaySlips = lazy(() => import("../CompanyModule/PayRoll/ViewPaySlips"));
const AddIncrement = lazy(() => import("../CompanyModule/PayRoll/Hike/AddIncrement"));
const ManageAttendance = lazy(() => import("../CompanyModule/Attendance/ManageAttendance"));
const AttendanceReport = lazy(() => import("../CompanyModule/Attendance/AttendanceReport"));
const EmployeePayslips = lazy(() => import("../EmployeeModule/EmployeePayslips"));
const CompanySalaryStructure = lazy(() => import("../CompanyModule/Settings/CompanySalaryStructure"));
const EmployeeSalaryList = lazy(() => import("../CompanyModule/PayRoll/EmployeeSalaryList"));
const Profile = lazy(() => import("../LayOut/Profile"));
const EmployeeSalaryById = lazy(() => import("../EmployeeModule/EmployeeSalaryById"));
const EmployeeProfile = lazy(() => import("../EmployeeModule/EmployeeProfile"));
const EmployeeSalaryUpdate = lazy(() => import("../CompanyModule/PayRoll/EmployeeSalaryUpdate"));
const CompanySalaryView = lazy(() => import("../CompanyModule/Settings/CompanySalaryView"));
const ExperienceLetter = lazy(() => import("../CompanyModule/Settings/Experience/ExperienceLetter"));
const ExperienceForm = lazy(() => import("../CompanyModule/Settings/Experience/ExperienceForm"));
const RelievingLetter = lazy(() => import("../CompanyModule/Settings/Relieving/RelievingLetter"));
const Preview = lazy(() => import("../CompanyModule/Settings/Relieving/Preview"));
const AppraisalTemplate = lazy(() => import("../CompanyModule/Settings/Appraisal/AppraisalTemplate"));
const InternShipTemplates = lazy(() => import("../CompanyModule/Settings/Internship/InternShipTemplates"));
const InternShipForm = lazy(() => import("../CompanyModule/Settings/Internship/InternShipForm"));
const PayslipUpdate1 = lazy(() => import("../CompanyModule/PayRoll/PayslipUpdate/PayslipUpdate1"));
const PayslipUpdate2 = lazy(() => import("../CompanyModule/PayRoll/PayslipUpdate/PayslipUpdate2"));
const PayslipUpdate3 = lazy(() => import("../CompanyModule/PayRoll/PayslipUpdate/PayslipUpdate3"));
const PayslipUpdate4 = lazy(() => import("../CompanyModule/PayRoll/PayslipUpdate/PayslipUpdate4"));
const PayslipTemplates = lazy(() => import("../CompanyModule/Settings/PayslipTemplates"));
const IdCardTemplates = lazy(() => import("../CompanyModule/Settings/IdCardTemplates"));
const IdCardManagement = lazy(() => import("../CompanyModule/Employee/IdCardManagement"));
const PayslipDoc1 = lazy(() => import("../CompanyModule/PayRoll/Payslips/PayslipDoc1"));
const PayslipDoc3 = lazy(() => import("../CompanyModule/PayRoll/Payslips/PayslipDoc3"));
const PayslipDoc2 = lazy(() => import("../CompanyModule/PayRoll/Payslips/PayslipDoc2"));
const PayslipDoc4 = lazy(() => import("../CompanyModule/PayRoll/Payslips/PayslipDoc4"));
const OfferLetters = lazy(() => import("../CompanyModule/Settings/OfferLetter/OfferLetters"));
const Template = lazy(() => import("../CompanyModule/Settings/OfferLetter/Template"));
const OfferLetterForm = lazy(() => import("../CompanyModule/Settings/OfferLetter/OfferLetterForm"));
const OfferLetterPreview = lazy(() => import("../CompanyModule/Settings/OfferLetter/OfferLetterPreview"));
const AccountRegistration = lazy(() => import("../InvoiceModule/AccountDetails/AccountRegistration"));
const AccountsView = lazy(() => import("../InvoiceModule/AccountDetails/AccountsView"));
const CustomersRegistration = lazy(() => import("../InvoiceModule/Customers/CustomerRegistration"));
const CustomersView = lazy(() => import("../InvoiceModule/Customers/CustomersView"));
const InvoiceRegistration = lazy(() => import("../InvoiceModule/Invoice/InvoiceRegistration"));
const InvoiceView = lazy(() => import("../InvoiceModule/Invoice/InvoiceView"));
const InvoicePdf = lazy(() => import("../InvoiceModule/Invoice/InvoicePdf"));
const EmployeeRegister = lazy(() => import("../CompanyModule/Employee/EmployeeRegister"));
const EmployeeSalaryStructureView = lazy(() => import("../CompanyModule/PayRoll/EmployeeSalaryStructureView"));
const InternOfferLetter = lazy(() => import("../CompanyModule/Settings/Internship/InternOfferLetter/InternOfferLetter"));
const InternOfferCustomTemplateBuilder = lazy(() => import("../CompanyModule/Settings/Internship/InternOfferLetter/CustomTemplate/InternOfferCustomTemplateBuilder"));
const InternShipCustomTemplateBuilder = lazy(() => import("../CompanyModule/Settings/Internship/CustomTemplate/InternShipCustomTemplateBuilder"));
const ExperienceCustomTemplateBuilder = lazy(() => import("../CompanyModule/Settings/Experience/CustomTemplate/ExperienceCustomTemplateBuilder"));
const RelievingCustomTemplateBuilder = lazy(() => import("../CompanyModule/Settings/Relieving/CustomTemplate/RelievingCustomTemplateBuilder"));
const AppraisalCustomTemplateBuilder = lazy(() => import("../CompanyModule/Settings/Appraisal/CustomTemplate/AppraisalCustomTemplateBuilder"));
const OfferLetterCustomTemplateBuilder = lazy(() => import("../CompanyModule/Settings/OfferLetter/CustomTemplate/OfferLetterCustomTemplateBuilder"));
const InternOfferPrev = lazy(() => import("../CompanyModule/Settings/Internship/InternOfferLetter/InternOfferPrev"));
const InternOfferForm = lazy(() => import("../CompanyModule/Settings/Internship/InternOfferLetter/InternOfferForm"));
const EventForm = lazy(() => import("../Calender/EventForm"));
const GetTaxSlab = lazy(() => import("../CompanyModule/TDS/GetTaxSlab"));
const CompanyTdsView = lazy(() => import("../CompanyModule/TDS/CompanyTdsView"));
const TotalEmployees = lazy(() => import("../EmployeeModule/TotalEmployees"));
const EmployeeList = lazy(() => import("../EmployeeModule/EmployeeList"));
const UpdateUser = lazy(() => import("../CompanyModule/UserModue/UpdateUser"));
const AddUser = lazy(() => import("../CompanyModule/UserModue/AddUser"));
const ViewUser = lazy(() => import("../CompanyModule/UserModue/ViewUser"));
const AddTaxSlab = lazy(() => import("../CompanyModule/TDS/AddTaxSlab"));
const CandidateRegistration = lazy(() => import("../CompanyModule/Candidate/CandidateRegistration"));
const CandidatesView = lazy(() => import("../CompanyModule/Candidate/CandidatesView"));
const CandidateDocumentUpload = lazy(() => import("../CompanyModule/Candidate/CandidateDocumentUpload"));
const CandidateProfile = lazy(() => import("../CompanyModule/Candidate/CandidateProfile"));
const InvoiceTemplate1 = lazy(() => import("../CompanyModule/Settings/InvoiceTemplates/InvoiceTemplate1"));
const InvoiceTemplate2 = lazy(() => import("../CompanyModule/Settings/InvoiceTemplates/InvoiceTemplate2"));
const EmployeeDocumentUpload = lazy(() => import("../CompanyModule/Employee/EmployeeDocumentUpload"));
const EmployeeDocumentView = lazy(() => import("../CompanyModule/Employee/EmployeeDocumentView"));
const InvoiceTemplates = lazy(() => import("../CompanyModule/Settings/InvoiceTemplates/InvoiceTemplates"));
const CandidateToEmployee = lazy(() => import("../CompanyModule/Candidate/CandidateToEmployee"));
const CompanyGSTSubmission = lazy(() => import("../AccountantModule/GST/CompanyGSTSubmission"));
const EmployeeManager = lazy(() => import("../CompanyModule/Employee/EmployeeManager/EmployeeManager"));
const EmployeeSummary = lazy(() => import("../CompanyModule/Employee/EmployeeManager/EmployeeSummary"));
const PasswordManagementSummary = lazy(() => import("../CredentialsManagement/PasswordManagementSummary"));
const CompanyPFSubmission = lazy(() => import("../AccountantModule/PF/CompanyPFSubmission"));
const CompanyPTSubmission = lazy(() => import("../AccountantModule/ProfessionalTax/CompanyPTSubmission"));
const CompanyTDSSubmission = lazy(() => import("../AccountantModule/Tds/CompanyTDSSubmission"));
const Settings = lazy(() => import("../LayOut/Settings"));
const TimeLineDates = lazy(() => import("../CompanyModule/Settings/TimeLine/TimeLineDates"));
const LeaveManagement = lazy(() => import("../LeavesModule/LeaveManagement"));
const EmployeeSalaryView = lazy(() => import("../EmployeeModule/EmployeeSalaryView"));
const MyAttendance = lazy(() => import("../EmployeeModule/MyAttendance"));
const EmployeeIdCardPage = lazy(() => import("../EmployeeModule/MyIdCard/EmployeeIdCardPage"));
const MailConfig = lazy(() => import("../CompanyModule/Settings/MailConfig/MailConfig"));
const RecipientMailConfig = lazy(() => import("../CompanyModule/Settings/MailConfig/RecipientMailConfig"));
const DocumentsEmployeeList = lazy(() => import("../CompanyModule/Documents/DocumentsEmployeeList"));
const DocumentsEmployeeView = lazy(() => import("../CompanyModule/Documents/DocumentsEmployeeView"));

const routeConfig = [
  {
    path: "/main",
    element: <Body />,
    allowedRoles: ["all"],
    allowedResourceTypes: ["all"],
    // Candidates have no dashboard; send them to their documents page instead
    redirectResourceTypes: { candidate: "/documentUpload" },
    label: "Dashboard",
    icon: "speedometer2",
  },
  {
    label: "Company",
    icon: "building",
    children: [
      {
        path: "/companyRegistration",
        element: <CompanyRegistration />,
        allowedRoles: ["ems_admin"],
        allowedResourceTypes: ["ems_admin"],
        label: "Register Company",
      },
      {
        path: "/companyView",
        element: <CompanyView />,
        allowedRoles: ["ems_admin"],
        allowedResourceTypes: ["ems_admin"],
        label: "View Companies",
      },
    ],
  },
  {
    path: "/editUser/:id",
    element: <UpdateUser />,
    allowedRoles: [
      "hrm",
      "tax_consultant",
      "hr_management",
      "invoice_management",
      "ca",
    ],
    allowedResourceTypes: ["company_admin", "Accountant", "HR", "Admin"],
  },
  {
    path: "/profile",
    element: <Profile />,
    allowedRoles: ["hrm", "tax_consultant"],
    allowedResourceTypes: ["company_admin"],
  },
  // Employee-specific
  {
    path: "/employeeProfile",
    element: <EmployeeProfile />,
    allowedRoles: ["employee"],
    allowedResourceTypes: ["employee"],
  },

  {
    path: "/employeeSalariesView",
    element: <EmployeeSalaryById />,
    allowedRoles: ["employee"],
    allowedResourceTypes: ["employee"],
    label: "Salary Summary",
    icon: "wallet2", // bi-wallet2 - better represents salary or financial data
  },
  {
    path: "/employeePayslip",
    element: <EmployeePayslips />,
    allowedRoles: ["employee"],
    allowedResourceTypes: ["employee"],
    label: "Payslips",
    icon: "receipt", // bi-receipt - ideal for payslip documents
  },

  {
    path: "/employeeDocumentUpload",
    element: <EmployeeDocumentUpload />,
    allowedRoles: ["employee"],
    allowedResourceTypes: ["employee"],
    label: "Documents",
    icon: "cloud-arrow-up", // bi-cloud-arrow-up - represents uploading
  },
  {
    path: "/myAttendance",
    element: <MyAttendance />,
    allowedRoles: ["employee"],
    allowedResourceTypes: ["employee"],
    label: "My Attendance",
    icon: "calendar-check",
  },
  {
    path: "/myIdCard",
    element: <EmployeeIdCardPage />,
    allowedRoles: ["employee"],
    allowedResourceTypes: ["employee"],
    label: "My ID Card",
    icon: "person-badge",
  },
  {
    path: "/employeeSalaryView",
    element: <EmployeeSalaryView />,
    allowedRoles: ["employee"],
    allowedResourceTypes: ["employee"],
  },


  // Company Admin & HR Shared
  {
    path: "/department",
    element: <Department />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
    label: "Department",
    icon: "diagram-3",
  },
  {
    path: "/branch",
    element: <Branch />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "Admin"],
    label: "Branches",
    icon: "diagram-3",
  },
  {
    path: "/settings",
    element: <Settings />,
    allowedRoles: ["hrm", "hr_management", "tax_consultant", "ca", "ems_admin"],
    allowedResourceTypes: ["Admin", "company_admin", "HR", "Accountant", "ems_admin"],
    label: "Settings",
    icon: "diagram-3", // Bootstrap icon
  },
  {
    label: "Candidates",
    icon: "person-badge", // Bootstrap icon suggestion: bi-person-vcard
    children: [
      {
        path: "/candidateRegistration",
        element: <CandidateRegistration />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Add Candidate",
        icon: "person-plus", // bi-person-plus
      },
      {
        path: "/candidatesView",
        element: <CandidatesView />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "View Candidates",
        icon: "people", // bi-people
      },
    ],
  },
  {
    label: "Employees",
    icon: "people", // Bootstrap Icon (bi-people)
    children: [
      {
        path: "/employeeRegister",
        element: <EmployeeRegister />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Add Employee",
        icon: "person-plus", // bi-person-plus
      },
      {
        path: "/employeeView",
        element: <EmployeeView />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "View Employees",
        icon: "person-lines-fill", // bi-person-lines-fill
      },
      {
        path: "/idCardManagement",
        element: <IdCardManagement />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "ID Cards",
        icon: "credit-card-2-front", // bi-credit-card-2-front
      },
    ],
  },
  {
    label: "Attendance",
    icon: "calendar-check", // Bootstrap icon: bi-calendar-check
    children: [
      {
        path: "/addAttendance",
        element: <ManageAttendance />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Add Attendance",
        icon: "clipboard-plus", // bi-clipboard-plus
      },
      {
        path: "/attendanceReport",
        element: <AttendanceReport />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Attendance Report",
        icon: "bar-chart-line", // bi-bar-chart-line
      },
    ],
  },
  {
    path: "/candidate-to-employee/:id",
    element: <CandidateToEmployee />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    icon: "file-earmark-text", // Bootstrap icon: bi-file-earmark-text
    path: "/offerLetterPreview",
    element: <OfferLetterPreview />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    label: "Generate Letters",
    icon: "envelope", // Example Bootstrap icon: bi-envelope-paper
    children: [

      {
        label: "Offer Letter",
        icon: "file-earmark-text", // Bootstrap icon: bi-file-earmark-text
        path: "/offerLetterForm",
        element: <OfferLetterForm />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
      },
      {
        label: "Internship",
        icon: "award",
        children: [
          {
            path: "/internOfferForm",
            element: <InternOfferForm />,
            allowedRoles: ["hrm", "hr_management"],
            allowedResourceTypes: ["company_admin", "HR", "Admin"],
            label: "Intern Offer Form",
            icon: "file-earmark-plus",
          },
          {
            path: "/internsLetter",
            element: <InternShipForm />,
            allowedRoles: ["hrm", "hr_management"],
            allowedResourceTypes: ["company_admin", "HR", "Admin"],
            label: "Internship Certificate",
            icon: "journal-richtext",
          },
        ],
      },
      {
        path: "/appraisalForm",
        element: <AddIncrement />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Appraisal",
        icon: "file-earmark-text", // Bootstrap icon: bi-graph-up-arrow
      },
      {
        label: "Experience",
        icon: "file-earmark-person",
        path: "/experienceForm",
        element: <ExperienceForm />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
      },

      {
        path: "/relievingSummary",
        element: <RelievingManagement />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Relieving",
        icon: "person-dash",
      },
    ],
  },
  {
    path: "/template",
    element: <Template />,
    allowedRoles: ["hrm", "ems_admin"],
    allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
  },

  {
    path: "/relivingReview",
    element: <Preview />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    path: "/internPrev",
    element: <InternOfferPrev />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    label: "Salary Management",
    icon: "wallet", // Bootstrap icon: bi-currency-rupee
    children: [
      {
        path: "/employeeSalaryStructure",
        element: <EmployeeSalaryStructure />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Add Salary Structure",
        icon: "file-earmark-plus", // bi-file-earmark-plus
      },
      {
        path: "/employeeSalaryList",
        element: <EmployeeSalaryStructureView />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Employee Salary List",
        icon: "file-earmark-spreadsheet", // Bootstrap icon: bi-file-earmark-spreadsheet
      },
      {
        path: "/payslipGeneration",
        element: <GeneratePaySlip />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Generate Payslip",
        icon: "file-earmark-ruled", // bi-file-earmark-ruled
      },
      {
        path: "/payslipsList",
        element: <ViewPaySlips />,
        allowedRoles: ["hrm", "hr_management"],
        allowedResourceTypes: ["company_admin", "HR", "Admin"],
        label: "Payslip List",
        icon: "file-earmark-spreadsheet", // bi-file-earmark-spreadsheet
      },
    ],
  },
  {
    path: "/payslipUpdate1",
    element: <PayslipUpdate1 />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    path: "/payslipUpdate2",
    element: <PayslipUpdate2 />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    path: "/payslipUpdate3",
    element: <PayslipUpdate3 />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    path: "/payslipUpdate4",
    element: <PayslipUpdate4 />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    label: "Employees Data",
    icon: "people",
    children: [
      {
        path: "/employeeMangement",
        element: <EmployeeManager />,
        label: "Employee Management",
        icon: "people-fill",
        allowedRoles: ["tax_consultant"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
      },
      {
        path: "/employeeSummary",
        label: "Employee Summary",
        element: <EmployeeSummary />,
        icon: "clipboard-data",
        allowedRoles: ["tax_consultant"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
      },
    ],
  },

  {
    path: "/employeeSalaryUpdate",
    element: <EmployeeSalaryUpdate />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },
  {
    path: "/getTaxSlab",
    element: <GetTaxSlab />,
    allowedRoles: [
      "hrm",
      "tax_consultant",
      "hr_management",
      "invoice_management",
      "ca",
      "employee",
    ],
    allowedResourceTypes: [
      "company_admin",
      "HR",
      "Admin",
      "Accountant",
      "employee",
    ],
  },
  {
    path: "/companyTdsView",
    element: <CompanyTdsView />,
    allowedRoles: [
      "hrm",
      "tax_consultant",
      "hr_management",
      "invoice_management",
      "ca", 'ems_admin'
    ],
    allowedResourceTypes: [
      "company_admin",
      "HR",
      "Admin",
      "Accountant",
      "employee", "ems_admin"
    ],
  },
  {
    path: "/addTaxSlab",
    element: <AddTaxSlab />,
    allowedRoles: ["hrm", "tax_consultant", "invoice_management", "ems_admin"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant", "ems_admin"],
  },
  {
    path: "/employeeSalaryListby",
    element: <EmployeeSalaryList />,
    allowedRoles: ["hrm", "hr_management"],
    allowedResourceTypes: ["company_admin", "HR", "Admin"],
  },

  // Company Admin & Accountant & hrm
  {
    label: "Clients Management",
    icon: "people", // Parent icon (Bootstrap icon)
    children: [
      {
        path: "/customerRegistration",
        element: <CustomersRegistration />,
        allowedRoles: ["hrm", "invoice_management"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
        label: "Add Client",
        icon: "person-plus", // bi-person-plus
      },
      {
        path: "/customersView",
        element: <CustomersView />,
        allowedRoles: ["hrm", "invoice_management"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
        label: "View Clients",
        icon: "people", // bi-people
      },
    ],
  },
  {
    label: "Invoice Management",
    icon: "file-text", // Bootstrap icon for invoice
    children: [
      {
        path: "/invoiceRegistration",
        element: <InvoiceRegistration />,
        allowedRoles: ["hrm", "invoice_management"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
        label: "Generate Invoice",
        icon: "file-earmark-plus", // bi-file-earmark-plus
      },

      {
        path: "/invoiceView",
        element: <InvoiceView />,
        allowedRoles: ["hrm", "invoice_management"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
        label: "View Invoices",
        icon: "file-earmark-ruled", // bi-file-earmark-ruled
      },
    ],
  },

  {
    path: "/companyPFSubmission",
    element: <CompanyPFSubmission />,
    label: "Provident Fund",
    icon: "file-earmark-arrow-down", // For document submission
    allowedRoles: ["hrm", "tax_consultant", "ca"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  },
  {
    path: "/companyPTSubmission",
    element: <CompanyPTSubmission />,
    label: "Professional Tax",
    icon: "file-earmark-arrow-down",
    allowedRoles: ["hrm", "tax_consultant", "ca"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  },

  {
    path: "/companyTDSSubmission",
    element: <CompanyTDSSubmission />,
    label: "TDS",
    icon: "file-earmark-arrow-down", // Document upload
    allowedRoles: ["hrm", "tax_consultant", "ca"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  },
  {
    path: "/companyGSTSubmission",
    element: <CompanyGSTSubmission />,
    allowedRoles: ["hrm", "tax_consultant", "ca"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
    label: "GST",
    icon: "file-earmark-text", // Invoice-like icon
  },

  // Product Management
  // {
  //   label: "Product Management",
  //   icon: "box-seam", // Bootstrap icon for products
  //   children: [
  //     {
  //       path: "/productRegistration",
  //       element: <ProductRegistration />,
  //       allowedRoles: ["hrm", "tax_consultant"],
  //       allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  //       label: "Product Registration",
  //       icon: "file-earmark-plus" // bi-file-earmark-plus
  //     },
  //     {
  //       path: "/productView",
  //       element: <ProductView />,
  //       allowedRoles: ["hrm", "tax_consultant"],
  //       allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  //       label: "View Products",
  //       icon: "boxes" // bi-boxes
  //     }
  //   ]
  // },

  {
    path: "/invoicePdf",
    element: <InvoicePdf />,
    allowedRoles: ["hrm", "tax_consultant", "invoice_management"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  },
  {
    path: "/leaveManagement",
    element: <LeaveManagement />,
    allowedRoles: ["hrm", "hr_management", "employee"],
    allowedResourceTypes: ["company_admin", "HR", "Admin", "employee"],
    label: "Leave Management",
    icon: "calendar-week", // Bootstrap icon
  },
  {
    path: "/invoiceTemplate1",
    element: <InvoiceTemplate1 />,
    allowedRoles: ["hrm", "tax_consultant", "invoice_management"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  },
  {
    path: "/invoiceTemplate2",
    element: <InvoiceTemplate2 />,
    allowedRoles: ["hrm", "tax_consultant", "invoice_management"],
    allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
  },

  // Employee & Accountant
  // Shared: company_admin, HR, employee & Accountant
  {
    path: "/payslipDoc1",
    element: <PayslipDoc1 />,
    allowedRoles: ["hrm", "tax_consultant", "hr_management"],
    allowedResourceTypes: ["company_admin", "Admin", "HR", "employee"],
  },
  {
    path: "/payslipDoc2",
    element: <PayslipDoc2 />,
    allowedRoles: ["hrm", "tax_consultant"],
    allowedResourceTypes: ["company_admin", "Admin", "HR", "employee"],
  },
  {
    path: "/payslipDoc3",
    element: <PayslipDoc3 />,
    allowedRoles: ["hrm", "tax_consultant", "hr_management"],
    allowedResourceTypes: ["company_admin", "Admin", "HR", "employee"],
  },
  {
    path: "/payslipDoc4",
    element: <PayslipDoc4 />,
    allowedRoles: ["hrm", "tax_consultant", "hr_management"],
    allowedResourceTypes: ["company_admin", "Admin", "HR", "employee"],
  },
  // {
  //   path: "/getcalendar",
  //   element: <GetCalendar />,
  //   allowedRoles: ["hrm", "tax_consultant", "employee"],
  //   allowedResourceTypes: [
  //     "company_admin",
  //     "Admin",
  //     "HR",
  //     "employee",
  //     "Accountant",
  //   ],
  //   label: "Calendar",
  //   icon: "calendar3" // Bootstrap Icons: https://icons.getbootstrap.com/icons/calendar3/
  // },
  // {
  //   path: "/taxSlab",
  //   element: <AddTaxSlab />,
  //   allowedRoles: ["hrm", "tax_consultant"],
  //   allowedResourceTypes: ["company_admin", "Admin"],
  //   label: "Tax Slabs",
  //   icon: "percent" // Bootstrap Icons: https://icons.getbootstrap.com/icons/percent/
  // },
  {
    path: "/totalEmployees",
    element: <TotalEmployees />,
    allowedRoles: ["hrm", "tax_consultant", "hr_management"],
    allowedResourceTypes: ["company_admin", "Admin", "HR", "Accountant"],
  },
  {
    path: "/employeeList/:status",
    element: <EmployeeList />,
    allowedRoles: ["hrm", "tax_consultant", "hr_management"],
    allowedResourceTypes: ["company_admin", "Admin", "HR", "Accountant"],
  },

  // Candidate-specific
  {
    path: "/candidateProfile",
    element: <CandidateProfile />,
    allowedRoles: ["candidate"],
    allowedResourceTypes: ["candidate"],
  },
  {
    path: "/documentUpload",
    element: <CandidateDocumentUpload />,
    allowedRoles: ["candidate"],
    allowedResourceTypes: ["candidate"],
    label: "Documents",
    icon: "file-earmark-arrow-up", // Suggested Bootstrap icon
  },
  {
    path: "/candidateDocumentsView",
    element: <CandidateDocumentUpload />,
    allowedRoles: ["candidate"],
    allowedResourceTypes: ["candidate"],
  },

  // Company Admin Only
  {
    label: "Users",
    icon: "people", // Bootstrap Icon (bi-person); use "people" for multiple users
    children: [
      {
        path: "/addUser",
        element: <AddUser />,
        allowedRoles: ["hrm", "tax_consultant", "hr_management", "invoice_management"],
        allowedResourceTypes: ["company_admin", "Admin"],
        label: "Add User",
        icon: "person-plus",
      },
      {
        path: "/viewUser",
        element: <ViewUser />,
        allowedRoles: [
          "hrm",
          "tax_consultant",
          "hr_management",
          "invoice_management",
        ],
        allowedResourceTypes: ["company_admin", "Admin"],
        label: "View Users",
        icon: "person-lines-fill",
      },
    ],
  },
  {
    path: "/documents",
    element: <DocumentsEmployeeList />,
    // Gated purely by resourceType (company_admin/Admin) — not by which functional
    // role checkbox (hr_management/ca) an Admin user happens to have been given in
    // User Creation, since that's an orthogonal permission axis to this feature.
    allowedRoles: ["all"],
    allowedResourceTypes: ["company_admin", "Admin"],
    label: "Documents",
    icon: "archive",
  },
  {
    path: "/documents/:employeeId",
    element: <DocumentsEmployeeView />,
    allowedRoles: ["all"],
    allowedResourceTypes: ["company_admin", "Admin"],
  },
  //  {
  //       path: "/passwordManager",
  //       element: <PasswordManagementSummary />,
  //       allowedRoles: ["ca"],
  //       allowedResourceTypes: ["Accountant"],
  //       label: "Password Manager",
  //       icon: "key" // Bootstrap Icon: https://icons.getbootstrap.com/icons/key/
  //     },
  {
    label: "Settings Card",
    icon: "gear",
    children: [
      {
        label: "Accounts",
        icon: "wallet", // or "file-invoice-dollar" if using FontAwesome
        children: [
          {
            path: "/accountRegistration",
            element: <AccountRegistration />,
            allowedRoles: ["hrm", "tax_consultant", "Admin"],
            allowedResourceTypes: ["company_admin"],
            label: "Add Account",
            icon: "person-plus",
          },
          {
            path: "/accountsView",
            element: <AccountsView />,
            allowedRoles: ["hrm", "tax_consultant", "Admin"],
            allowedResourceTypes: ["company_admin"],
            label: "View Accounts",
            icon: "person-lines-fill",
          },
        ],
      },
      {
        path: "/AddEvent",
        element: <EventForm />,
        allowedRoles: [
          "hrm",
          "tax_consultant",
          "hr_management",
          "invoice_management",
          "ca",
          "ems_admin",
        ],
        allowedResourceTypes: ["company_admin", "Admin", "HR", "ems_admin"],
        label: "Add Event",
        icon: "calendar-plus", // Bootstrap icon: bi-calendar-plus
      },
      {
        path: "/companyTdsView",
        element: <CompanyTdsView />, // Replace with your actual component
        allowedRoles: ["hrm", "tax_consultant", "hr_management", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Accountant", "Admin", "ems_admin"],
        label: "Add TDS",
        icon: "file-earmark-spreadsheet", // Suggested: bi-file-earmark-spreadsheet
      },
      {
        label: "Company Salary Structure",
        icon: "wallet", // or "file-invoice-dollar" if using FontAwesome
        children: [
          {
            path: "/companySalaryView",
            element: <CompanySalaryView />,
            allowedRoles: ["hrm", "hr_management", "ems_admin"],
            allowedResourceTypes: ["company_admin", "HR", "Admin", "ems_admin"],
            label: "Company Salary View",
            icon: "cash", // Suggested Bootstrap icon: bi-currency-dollar
          },
          {
            path: "/companySalaryStructure",
            element: <CompanySalaryStructure />,
            allowedRoles: ["hrm", "ems_admin"],
            allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
            label: "Add Company Salary Structure",
            icon: "cash",
          },
        ],
      },
      {
        path: "/internOfferTemplate",
        element: <InternOfferLetter />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "Intern Offer Template",
        icon: "file-earmark-text", // bi-file-earmark-text
      },
      {
        path: "/internOfferCustomTemplate",
        element: <InternOfferCustomTemplateBuilder />,
        allowedRoles: ["hrm"],
        allowedResourceTypes: ["company_admin", "Admin"],
      },
      {
        path: "/internShipCustomTemplate",
        element: <InternShipCustomTemplateBuilder />,
        allowedRoles: ["hrm"],
        allowedResourceTypes: ["company_admin", "Admin"],
      },
      {
        path: "/experienceCustomTemplate",
        element: <ExperienceCustomTemplateBuilder />,
        allowedRoles: ["hrm"],
        allowedResourceTypes: ["company_admin", "Admin"],
      },
      {
        path: "/relievingCustomTemplate",
        element: <RelievingCustomTemplateBuilder />,
        allowedRoles: ["hrm"],
        allowedResourceTypes: ["company_admin", "Admin"],
      },
      {
        path: "/appraisalCustomTemplate",
        element: <AppraisalCustomTemplateBuilder />,
        allowedRoles: ["hrm"],
        allowedResourceTypes: ["company_admin", "Admin"],
      },
      {
        path: "/offerLetterCustomTemplate",
        element: <OfferLetterCustomTemplateBuilder />,
        allowedRoles: ["hrm"],
        allowedResourceTypes: ["company_admin", "Admin"],
      },
      {
        path: "/offerLetterTemplate",
        element: <OfferLetters />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "Offer Templates",
        icon: "file-earmark-richtext", // Bootstrap icon (bi-file-earmark-richtext)
      },
      {
        path: "/payslipTemplates",
        element: <PayslipTemplates />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "Payslip Templates",
        icon: "file-earmark-ruled", // bi-file-earmark-ruled
      },
      {
        path: "/idCardTemplates",
        element: <IdCardTemplates />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "ID Card Templates",
        icon: "person-badge", // bi-person-badge
      },
      {
        path: "/internsTemplates",
        element: <InternShipTemplates />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "Internship Templates",
        icon: "person-badge", // bi-mortarboard
      },
      {
        path: "/appraisalTemplates",
        element: <AppraisalTemplate />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "Appraisal Templates",
        icon: "award", // bi-award
      },
      {
        path: "/relievingTemplates",
        element: <RelievingLetter />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "Relieving Templates",
        icon: "file-earmark-text", // Bootstrap icon: bi-file-earmark-text
      },
      {
        path: "/experienceLetter",
        element: <ExperienceLetter />,
        allowedRoles: ["hrm", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "ems_admin"],
        label: "Experience Letter",
        icon: "briefcase", // bi-briefcase
      },
      {
        path: "/invoiceTemplates",
        element: <InvoiceTemplates />,
        allowedRoles: ["hrm", "tax_consultant", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant", "ems_admin"],
        label: "Invoice Templates",
        icon: "file-earmark-text", // bi-file-earmark-text
      },
      {
        path: "/passwordManager",
        element: <PasswordManagementSummary />,
        allowedRoles: ["hrm", "tax_consultant", "ca"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant"],
        label: "Password Manager",
        icon: "key", // Bootstrap Icon: https://icons.getbootstrap.com/icons/key/
      },
      {
        path: "/timeLineDates",
        element: <TimeLineDates />,
        allowedRoles: ["hrm", "tax_consultant", "ems_admin"],
        allowedResourceTypes: ["company_admin", "Admin", "Accountant",  "HR", "ems_admin"],
        label: "TimeLines",
        icon: "hourglass-split", // Bootstrap Icon: https://icons.getbootstrap.com/icons/key/
      },
      {
        path: "/mailConfig",
        element: <MailConfig />,
        allowedRoles: ["ems_admin"],
        allowedResourceTypes: ["ems_admin"],
        label: "Mail Config",
        icon: "envelope-at",
      },
      {
        path: "/recipientMailConfig",
        element: <RecipientMailConfig />,
        allowedRoles: ["ems_admin"],
        allowedResourceTypes: ["ems_admin"],
        label: "Recipient Mail Config",
        icon: "people",
      },
    ],
  },
];

export default routeConfig;
